const WEAPON_TYPE_LABEL = {
  bow: '활',
  ballista: '바리스타',
  arquebus: '조총',
  cannon: '대포',
  rifle: '소총',
  naval_gun: '함포',
  missile: '미사일',
};

export { WEAPON_TYPE_LABEL };
